import * as Sentry from '@sentry/vue'
import OpenAIApi from '@/api/openai'
import SlideApi from '@/api/slide'
import utils from '@/util'
import i18nPresenter from '@/i18nPresenter'

// other actions
const UPDATE_SLIDE_BY_ID_ACTION = 'updateSlideByIdAction'
const SET_SNAPSHOT_BY_SLIDE_ID_ACTION = 'snapshot/setSnapshotAction'

// HELPERS
const prepareInputDataToImproveSlideContent = (params) => {
  const { mode, value } = params
  return {
    writingStyle: {
      [mode]: value,
    },
  }
}

const validateSlideObject = (slideObject, slideId) => {
  if (!slideObject || !slideObject.body || !slideObject.body.id || slideObject.body.id !== slideId) return false
  return true
}

const fetchCanvasBlocks = async (canvasBlocksUrl) => {
  if (!canvasBlocksUrl) return null

  const canvasBlocks = await fetch(canvasBlocksUrl).then((res) => res.json()).then((body) => ({ body }))
  if (!canvasBlocks || !canvasBlocks.body) return null
  return canvasBlocks.body
}

const updateSlideContentWithNewSlideObject = async (dispatch, slideObject, slideId) => {
  const newCanvasBlocksUrl = slideObject.canvasBlocksUrl
  const newCanvasBlocks = await fetchCanvasBlocks(newCanvasBlocksUrl)
  dispatch(UPDATE_SLIDE_BY_ID_ACTION, {
    id: slideId,
    canvasBlocks: newCanvasBlocks,
    canvasBlocksUrl: newCanvasBlocksUrl,
  }, { root: true })
}

const canRestoreOriginalSlide = (slideId, originalVersion) => {
  if (!slideId || !originalVersion) return false

  return originalVersion.id === slideId
}

const _state = {
}

const _getters = {
}

const actions = {
  async improveSlideContentAction({
    dispatch, rootState,
  }, params) {
    const slideId = rootState.slideActive && rootState.slideActive.id
    if (!slideId) return

    try {
      // call API improve slide content
      const improveWritingSettings = prepareInputDataToImproveSlideContent(params)
      const slideObject = await OpenAIApi.improveSlideContent({
        slideId,
        improveWritingSettings,
      })

      // check returned slideObject
      if (!validateSlideObject(slideObject, slideId)) return

      // take a snapshot for current slide
      dispatch(SET_SNAPSHOT_BY_SLIDE_ID_ACTION, { slideId }, { root: true })

      // update slide content
      await updateSlideContentWithNewSlideObject(dispatch, slideObject.body, slideId)

      utils.showToastSuccess(i18nPresenter.t('Slide content has been updated'))
    } catch (error) {
      Sentry.captureException(error)
      utils.showToastError(i18nPresenter.t('Something went wrong on our side. Please try again'))
    }
  },

  async restoreOriginalSlideAction({ dispatch, rootState, rootGetters }) {
    const originalVersion = rootGetters && rootGetters['snapshot/snapshot']
    const slideId = rootState.slideActive && rootState.slideActive.id
    try {
      if (!canRestoreOriginalSlide(slideId, originalVersion)) return

      // Back-end: Update slide content
      await SlideApi.updateSlideById(slideId, {
        canvasBlocks: originalVersion.canvasBlocks,
      })

      // Front-end: Update slide content
      dispatch(UPDATE_SLIDE_BY_ID_ACTION, {
        id: slideId,
        canvasBlocks: originalVersion.canvasBlocks,
      }, { root: true })
    } catch (error) {
      Sentry.captureException(error)
    }
  },
}

const mutations = {
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
